import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export const useConsolidatedTreasuryPermissions = () => {
  const auth = useAuth();

  return useMemo(() => {
    const empty = {
      canViewModule: false,
      canViewShipments: false,
      canCreateShipments: false,
      canUpdateShipmentStatus: false,
      canDeleteShipments: false,
      canViewCosting: false,
      canEditCosting: false,
      canViewAccountMasters: false,
      canManageAccountMasters: false,
      canCreateAccountMasters: false,
      canEditAccountMasters: false,
      canDeleteAccountMasters: false,
      canViewInvoices: false,
      canCreateInvoices: false,
      canGenerateInvoices: false,
      canDeleteInvoices: false,
      canViewCustomerPayments: false,
      canCreateCustomerPayments: false,
      canViewSupplierBills: false,
      canCreateSupplierBills: false,
      canViewSupplierPayments: false,
      canCreateSupplierPayments: false,
      canViewDashboard: false,
      canViewReports: false,
      canExportData: false,
      canViewTreasury: false,
      canExportTreasury: false,
      canViewTreasuryAccounts: false,
      canCreateTreasuryAccounts: false,
      canEditTreasuryAccounts: false,
      canDeleteTreasuryAccounts: false,
      canViewTreasuryMovements: false,
      canCreateTreasuryMovements: false,
      canCreateTreasuryTransfers: false,
    };

    if (!auth) return empty;

    if (auth.user?.is_superadmin) {
      return {
        ...empty,
        canViewTreasury: true,
        canExportTreasury: true,
        canViewTreasuryAccounts: true,
        canViewTreasuryMovements: true,
      };
    }

    const hasPermission = (key) => auth.hasPermission?.(key) || false;
    const canView = hasPermission("Finance.TresorerieConsolidee.view");
    const canExport = hasPermission("Finance.TresorerieConsolidee.export");

    return {
      ...empty,
      canViewTreasury: canView,
      canExportTreasury: canExport,
      canViewTreasuryAccounts: canView,
      canViewTreasuryMovements: canView,
    };
  }, [auth]);
};
